// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2dA3S","content":"GlobalSearch_content__3H9f0"};